import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationStart } from '@angular/router';
import { DialogRef, ModalComponent } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { overlayConfigFactory } from 'angular2-modal';
import { enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
import { loyaltyOTPverificationComponent } from './loyalty-login.component-Step3';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';

//Services
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { loyaltylogin } from '../../_services/userservice/user.loyaltylogin.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
export class LoyaltyLoginStep2ModalContext extends BSModalContext {
  public loyaltyCardModel: any;
}

var target;
@Component({
  selector: 'app-loyalty-login-step2',
  templateUrl: './loyalty-login.component-Step2.html',
  styleUrls: ['./loyalty-login.component.css'],
  providers: [AlertService]
})
export class loyaltyCardverificationComponent implements ModalComponent<LoyaltyLoginStep2ModalContext> {
  context: LoyaltyLoginStep2ModalContext;
  model: any = {};
  constructor(
    public dialog: DialogRef<LoyaltyLoginStep2ModalContext>,
    public utilserv: utilityService,
    private loyallog: loyaltylogin,
    public modal: Modal,
    public translate: TranslateService,
    private alertService: AlertService,
    public geoloc: geolocation,
    private router: Router
  ) {
    this.context = dialog.context;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
  }
  ngOnInit() {
    this.model.MobileNumber = this.context.loyaltyCardModel.MobileNumber;
    this.model.CustomerEmail = this.context.loyaltyCardModel.CustomerEmail;
  }

  SendOTP(event) {
    target = event.currentTarget;
    this.context.loyaltyCardModel.methodName = target.name;
    if (target.name === 'CUSTOMERCARE') {
      // Call Customer Care
      this.callCustomerCare();
      // this.alertService.openErrorAlert('callCustomerCare_ConfirmyourAccountPopup',
      //                                  'Please Call Customer Care');
    } else {
      this.genrateOTP(this.context.loyaltyCardModel.methodName, this.context.loyaltyCardModel.loyaltyCardNumber);
    }
  }
  callCustomerCare() {
    const CountryObject: any = this.geoloc.getCountryObject();
    if (CountryObject.CustomerCareNumber && CountryObject.CustomerCareNumber != undefined) {
      this.alertService.openErrorAlert(
        this.translate.instant('Common_lblInfo'),
        this.translate.instant('Message_lblCustomerCareContactPrefix') + ' ' + CountryObject.CustomerCareNumber + ' ' + this.translate.instant('Message_lblCustomerCareContactSuffix')
      );
    } else {
      this.alertService.openErrorAlert(this.translate.instant('Common_lblInfo'), this.translate.instant('Message_customerCareError'));
    }
  }
  genrateOTP(methodName: string, loyaltyCardNumber: string) {
    const otpModel: any = {};
    otpModel.methodname = methodName;

    otpModel.OTPName = this.context.loyaltyCardModel.OTPName != '' && this.context.loyaltyCardModel.OTPName != undefined ? this.context.loyaltyCardModel.OTPName : 'LoyaltyCardNumber';
    otpModel.OTPValue = this.context.loyaltyCardModel.OTPValue != '' && this.context.loyaltyCardModel.OTPValue != undefined ? this.context.loyaltyCardModel.OTPValue : loyaltyCardNumber;
    this.utilserv.busy = this.loyallog.generateOTP(otpModel).subscribe(
      data => {
        const resJSON = data;
        if (resJSON.Envelope.Body.ResponseBase.StatusCode == enumStatusCodeList.SUCCESS) {
          this.context.loyaltyCardModel.loyaltyCardNumber = loyaltyCardNumber;
          this.dialog.close();
          this.openLoyaltyCardOTPVerificationStep3(this.context.loyaltyCardModel.methodName, this.context.loyaltyCardModel);
        } else {
          this.alertService.openErrorAlert(this.translate.instant('Message_errorMessage'), resJSON.Envelope.Body.ResponseBase.StatusMessage);
        }
      },
      error => {
        console.log('Observer got a next value: ' + error);
        this.alertService.openErrorAlert(this.translate.instant('Message_errorMessage'), this.translate.instant('Message_errorMessage'));
        this.closePopup();
      }
    );
    // this.loading = true;
  }
  openLoyaltyCardOTPVerificationStep3(methodName: string, loyaltyCardModel: any) {
    console.log('methodName: ' + methodName);
    loyaltyCardModel.isLoggedIn = this.context.loyaltyCardModel.isLoggedIn;
    return this.modal.open(loyaltyOTPverificationComponent, overlayConfigFactory({ loyaltyCardModel }, BSModalContext));
  }

  //for closing existing dialog Box
  closePopup() {
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/user/loyalty-login/loyalty-login.component-Step2.ts